export default "__VITE_ASSET__DEiWjMWe__"